export default {
  "rtl": "_5EGMs",
  "ltr": "nTL-N"
};